module.exports = __webpack_public_path__ + "media/img/corporate/mini-0c15964589314942cede757ba9c63643.svg";